<template>
    <div class="root">

        <div :id="p_mapUid_s"
             :style="{'zIndex': gv_zIndex.tqLeafLet_map}"
             class="TQ_bg_white TQ_height_100p">
        </div>

        <!-- more info-->
        <!--<tq-more-info :p_more-info-id_uid="enum_moreInfo_helpersIds_s.helpers_edit_map_route"-->
        <!--              class="TQ_width_32px lc_moreInfo TQ_margin_4px TQ_bg_white TQ_borderRadius TQ_padding_4px TQ_box_shadow"/>-->


        <div class="lc_btns TQ_width_52px TQ_align_end TQ_direction_rtl">

            <img title="Add"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_add_b"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.add)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.add_rectangles, editStateOptions_byName_n.add_markers, editStateOptions_byName_n.add_path,
                 editStateOptions_byName_n.add_polygons, editStateOptions_byName_n.add_overlay_image].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Edit"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_edit"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.edit)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.edit_rectangles, editStateOptions_byName_n.edit_path,
                 editStateOptions_byName_n.edit_polygons, editStateOptions_byName_n.edit_markers, editStateOptions_byName_n.edit_overlay_image].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Delete"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_garbage"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.delete)"
                 :class="{'TQ_bg_gold' : [ editStateOptions_byName_n.delete_markers, editStateOptions_byName_n.delete_path,
                  editStateOptions_byName_n.delete_polygons, editStateOptions_byName_n.delete_rectangles, editStateOptions_byName_n.delete_overlay_image].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_4px" />

            <img title="Polygon"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_polygon"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.polygons)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.add_polygons, editStateOptions_byName_n.edit_polygons, editStateOptions_byName_n.delete_polygons].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Riddle Rectangle"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 v-if="[enum_openMapTypes.squares , enum_openMapTypes.squares_hide, enum_openMapTypes.squares_linear, enum_openMapTypes.squares_linear_groups, enum_openMapTypes.squares_linear_groups_hide].includes(p_qb_metadata_c.qbm_mapMissions_missionsType_e) && p_missionsEditable_b"
                 :src="ass_img_square"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.riddle_rectangle)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.add_rectangles, editStateOptions_byName_n.edit_rectangles,
                 editStateOptions_byName_n.delete_rectangles].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Riddle Marker"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 v-if="[enum_openMapTypes.markers, enum_openMapTypes.markers_route].includes(p_qb_metadata_c.qbm_mapMissions_missionsType_e) && p_missionsEditable_b"
                 :src="ass_img_locationPin"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.riddle_marker)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.add_markers, editStateOptions_byName_n.edit_markers, editStateOptions_byName_n.delete_markers].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Path"
                 v-if="enum_openMapTypes.markers_route === p_qb_metadata_c.qbm_mapMissions_missionsType_e && p_missionsEditable_b"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_line_c"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.edit_path)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.edit_path, editStateOptions_byName_n.delete_path].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

            <img title="Overlay Image"
                 :style="{'zIndex': gv_zIndex.tqLeafLet_btns}"
                 :src="ass_img_image2"
                 @click="m_userEvents_clickEditBtn_f(editStateOptions_byName_n.overlay_image)"
                 :class="{'TQ_bg_gold' : [editStateOptions_byName_n.add_overlay_image, editStateOptions_byName_n.edit_overlay_image,
                 editStateOptions_byName_n.delete_overlay_image].includes(editState_n)}"
                 class="TQ_width_20px TQ_bg_white TQ_box_shadow TQ_padding_4px TQ_margin_bottom_-2px"/>

        </div>

    </div>
</template>

<script>
    import L from 'leaflet'
    import "leaflet/dist/leaflet.css";

    import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

    import {
        validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {
        enum_mapMissionsTypes,
        enum_mapTypes, enum_moreInfo_helpersIds_s
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        ass_img_add_b,
        ass_img_edit,
        ass_img_garbage,
        ass_img_image,
        ass_img_line_c,
        ass_img_image2,
        ass_img_locationPin,
        ass_img_polygon,
        ass_img_square,
        ass_img_square_w
    } from "@/assets/scripts/Ass_Files";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {notification_notify} from "@/scripts/S_Notification";
    import {svg_getMarkerFinishHtml_s, svg_getMarkerHtml_s} from "@/scripts/S_Svg";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";
    import {
        validator_arrayClass_fb,
        validator_null_fb, validator_objClass_fb
    } from "../../../functions/src/shareCode/Share_S_Validator";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {
        FB_MapData,
        FB_MapData_OverlayImage, FB_MapData_Polygon,
        FB_MapPoint,
        FB_QuestBody_Metadata, FB_QuestBody_MissionsGroup, FB_QuestBody_Riddle,
        FB_UserData
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes, enum_oppositeOperators, enum_typeof} from "../../../functions/src/shareCode/Share_S_Enum";
    import {obj_forEach_f, obj_map_fo, obj_size_fn, obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqMoreInfo from "../basic2/TqMoreInfo";
    import GestureHandling from "leaflet-gesture-handling";

    export default {
        name: "TqLeafletEdit",
        components: {TqMoreInfo},
        props:{
            p_mapUid_s : {
                type: String,
                default: "mapid"
            },
            p_mapData_c : {
                type: FB_MapData,
                require: true,
            },
            p_display_langCode_e:{
                type: String,
                validator(val){
                    return validator_null_fb(val) || validator_enum_fb(enum_langCodes, val)
                }
            },
            p_qb_metadata_c:{
                type: FB_QuestBody_Metadata,
                require: true
            },

            // riddles
            p_qb_riddles_ac:{
                type: Array,
                validator(arr){
                    return validator_null_fb(arr) || validator_arrayClass_fb(arr, FB_QuestBody_Riddle)
                }
            },
            p_missionGroups_ac:{
                type: Array,
                default() {return []},
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_QuestBody_MissionsGroup)
                }
            },
            p_teamPlayersData_byPlayerId_c:{
                type: Object,
                default() {
                    return {}
                },
                validator(obj){
                    return validator_null_fb(obj) || validator_objClass_fb(obj, FB_UserData)
                }
            },
            p_missionsEditable_b:{
                type : Boolean,
                default : true
            },

            //  =========== prop emit functions ===============
            pe_addQuestBodyRiddle_c : {
                type : Function,
            },
            pe_chooseImage_f : {
                type : Function,
                default: ()=>{}
            },
            p_onClickRiddle_f:{
                type: Function,
                require: true
            },
        },
        data(){
            return {
                mymap_l                     : null,
                editMarkers_al              : [],
                editMarkers_byGroupId_al    : {},
                polygons_al                 : [],   // al => array of leaflet object
                rectangles_al               : [],   // al => array of leaflet object
                overlayImages_al               : [],   // al => array of leaflet object
                rectangles_images_byRiddleIndexL : {},
                rectangles_numbersMarkers_al: [],
                riddles_markers_al          : [],
                playerLocation_al           : [],
                playerLocation_accuracy_al  : [],
                playerLocation_names_al     : [],
                riddles_paths_al            : [],
                currentLocation_marker_l    : null,
                currentUserLocation_accuracy_l  : null,

                lastBackgroundImage_o : null,

                pathDisplayRightLeftDraggableMarkers_minSlop : 0.1,

                editStateOptions_byName_n : {
                    polygons            : 'polygon',
                    riddle_marker       : 'riddle_marker',
                    riddle_rectangle    : 'riddle_rectangle',
                    overlay_image       : 'overlay_image',

                    edit                : 'edit',
                    delete              : 'delete',
                    add                 : 'add',

                    edit_overlay_image  : 'edit_overlay_image',
                    edit_rectangles     : 'edit_rectangles',
                    edit_markers        : 'edit_markers',
                    edit_path           : 'edit_path',
                    edit_polygons       : 'edit_polygons',

                    add_overlay_image   : 'add_overlay_image',
                    add_rectangles      : 'add_rectangles',
                    add_markers         : 'add_markers',
                    add_path            : 'add_path',
                    add_polygons        : 'add_polygons',

                    delete_overlay_image: 'delete_overlay_image',
                    delete_rectangles   : 'delete_rectangles',
                    delete_markers      : 'delete_markers',
                    delete_path         : 'delete_path',
                    delete_polygons     : 'delete_polygons',
                },
                editState_n : null,
                clickDragMarker_b : false,

                new_polyline : null,
                new_latLngs : null,
                new_firstLatlng : null,

                // import
                gv_zIndex           : gv_zIndex,
                ass_img_add_b       : ass_img_add_b,
                ass_img_edit        : ass_img_edit,
                ass_img_polygon     : ass_img_polygon,
                ass_img_garbage     : ass_img_garbage,
                ass_img_square      : ass_img_square,
                ass_img_image       : ass_img_image,
                ass_img_locationPin : ass_img_locationPin,
                ass_img_line_c      : ass_img_line_c,
                ass_img_image2      : ass_img_image2,
                enum_openMapTypes   : enum_mapMissionsTypes,
                enum_mapTypes   : enum_mapTypes,
                enum_moreInfoIds_s: enum_moreInfo_helpersIds_s,


                svg_getMarkerHtml_s         : svg_getMarkerHtml_s,
                svg_getMarkerFinishHtml_s   : svg_getMarkerFinishHtml_s,
            }
        },
        computed:{
            co_getMinDistance_fn(){
                return Math.pow((21 - this.mymap_l.getZoom()), 2) * gv_numbers.leafletMinDistance_n
            },
        },
        methods:{

            // ========== userEvents ==========
            m_userEvents_clickEditBtn_f(newEditState_e){

                // 1) clear all
                this.m_userEvents_clickEditBtn_editMarkers_clear_f()

                // 2) if click the same btn
                if(this.editState_n === newEditState_e){
                    this.editState_n = null
                    return
                }

                // 3) set editAction
                switch(newEditState_e){

                    case this.editStateOptions_byName_n.add:


                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.add_overlay_image:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.delete_rectangles:
                                this.editState_n = this.editStateOptions_byName_n.add_rectangles
                                break;

                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.delete_markers:
                                this.editState_n = this.editStateOptions_byName_n.add_markers
                                break;

                            case this.editStateOptions_byName_n.edit_overlay_image:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.add_overlay_image
                                break;

                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.delete_polygons:
                            default:
                                this.editState_n = this.editStateOptions_byName_n.add_polygons;

                        }
                        break;

                    case this.editStateOptions_byName_n.edit:

                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.delete_rectangles:
                                this.editState_n = this.editStateOptions_byName_n.edit_rectangles
                                this.m_userEvents_clickEditBtn_editRiddleRectangle_set_f()

                                break;
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.delete_markers:
                                this.editState_n = this.editStateOptions_byName_n.edit_markers
                                this.m_userEvents_clickEditBtn_editRiddleMarker_set_f()
                                break;

                            case this.editStateOptions_byName_n.add_overlay_image:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.edit_markers
                                this.m_userEvents_clickEditBtn_editImageOverlay_set_f()
                                break;

                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.delete_polygons:
                            default:
                                this.editState_n = this.editStateOptions_byName_n.edit_polygons;
                                this.m_userEvents_clickEditBtn_editPolygons_set_f()

                        }
                        break;

                    case this.editStateOptions_byName_n.delete:

                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.delete_rectangles:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.delete_path:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.edit_rectangles:
                                this.editState_n = this.editStateOptions_byName_n.delete_rectangles

                                break;
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.edit_markers:
                                this.editState_n = this.editStateOptions_byName_n.delete_markers
                                break;

                            case this.editStateOptions_byName_n.add_overlay_image:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.delete_overlay_image
                                break;

                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.edit_polygons:
                            default:
                                this.editState_n = this.editStateOptions_byName_n.delete_polygons;

                        }
                        break;

                    case this.editStateOptions_byName_n.polygons:

                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.add_polygons:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.edit_polygons;
                                this.m_userEvents_clickEditBtn_editPolygons_set_f()
                                break;

                            case this.editStateOptions_byName_n.delete_path:
                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.delete_rectangles:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.delete_polygons;
                                break;

                            case this.editStateOptions_byName_n.add_path:
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.add_overlay_image:
                            default :
                                this.editState_n = this.editStateOptions_byName_n.add_polygons;

                        }
                        break;

                    case this.editStateOptions_byName_n.riddle_marker:
                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.add_markers:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.edit_markers;
                                this.m_userEvents_clickEditBtn_editRiddleMarker_set_f()
                                break;

                            case this.editStateOptions_byName_n.delete_path:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.delete_rectangles:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.delete_markers;
                                break;

                            case this.editStateOptions_byName_n.add_path:
                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.add_overlay_image:
                            default :
                                this.editState_n = this.editStateOptions_byName_n.add_markers;

                        }
                        break;

                    case this.editStateOptions_byName_n.riddle_rectangle:
                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.delete_rectangles:
                            case this.editStateOptions_byName_n.add_rectangles:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.edit_rectangles;
                                this.m_userEvents_clickEditBtn_editRiddleRectangle_set_f()
                                break;

                            case this.editStateOptions_byName_n.delete_path:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.delete_rectangles;
                                break;

                            case this.editStateOptions_byName_n.add_path:
                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.add_overlay_image:
                            default :
                                this.editState_n = this.editStateOptions_byName_n.add_rectangles;

                        }
                        break;

                    case this.editStateOptions_byName_n.overlay_image:
                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_overlay_image:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                            case this.editStateOptions_byName_n.add_overlay_image:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.edit_rectangles:
                                this.editState_n = this.editStateOptions_byName_n.edit_overlay_image;
                                this.m_userEvents_clickEditBtn_editImageOverlay_set_f()
                                break;

                            case this.editStateOptions_byName_n.delete_path:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.delete_rectangles:
                                this.editState_n = this.editStateOptions_byName_n.delete_overlay_image;
                                break;

                            case this.editStateOptions_byName_n.add_path:
                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.add_rectangles:
                            default :
                                this.editState_n = this.editStateOptions_byName_n.add_overlay_image;

                        }
                        break;

                    case this.editStateOptions_byName_n.edit_path:

                        switch(this.editState_n){

                            case this.editStateOptions_byName_n.edit_path:
                            case this.editStateOptions_byName_n.edit:
                                this.editState_n = null
                                break;

                            case this.editStateOptions_byName_n.delete_markers:
                            case this.editStateOptions_byName_n.delete_rectangles:
                            case this.editStateOptions_byName_n.delete_polygons:
                            case this.editStateOptions_byName_n.delete_overlay_image:
                                this.editState_n = this.editStateOptions_byName_n.delete_path;
                                break;

                            case this.editStateOptions_byName_n.add_rectangles:
                            case this.editStateOptions_byName_n.add_polygons:
                            case this.editStateOptions_byName_n.add_markers:
                            case this.editStateOptions_byName_n.add_overlay_image:

                            case this.editStateOptions_byName_n.edit_markers:
                            case this.editStateOptions_byName_n.edit_rectangles:
                            case this.editStateOptions_byName_n.edit_polygons:
                            case this.editStateOptions_byName_n.edit_overlay_image:
                            default :
                                this.editState_n = this.editStateOptions_byName_n.edit_path;
                                this.m_userEvents_clickEditBtn_editPath_set_f()
                                break;

                        }
                        break;

                }
            },
            m_userEvents_clickEditBtn_editPolygons_set_f(){


                this.polygons_al = this.polygons_al.filter(polygon_l => {
                    let latlngs_al = polygon_l.getLatLngs()[0]
                    return latlngs_al.length > 0
                })


                this.polygons_al.forEach((polygon_l, polygonIndex_n) => {

                    let latlngs_al = polygon_l.getLatLngs()[0]
                    let dragableMarkers_al = []

                    // move corners
                    latlngs_al.forEach((latlng_l,latlngIndex_n) => {
                        dragableMarkers_al.push(this.m_addDraggableMarker_fl(
                            new FB_MapPoint({mp_lng_n : latlng_l.lng , mp_lat_n : latlng_l.lat}),
                            (newLatLng_o)=> {
                                latlngs_al[latlngIndex_n] = newLatLng_o
                                polygon_l.setLatLngs(latlngs_al)

                                this.$set(this.p_mapData_c.md_polygons_ac[polygonIndex_n].mdp_points_byIndex_c, latlngIndex_n, new FB_MapPoint({mp_lng_n : newLatLng_o.lng , mp_lat_n : newLatLng_o.lat}))
                            }))
                    })

                    // move center
                    let currentCenter_c = this.m_polygonCenter_fc(latlngs_al)
                    this.editMarkers_al.push(this.m_addDraggableMarker_fl(
                        currentCenter_c,
                        (newLatLng)=> {

                            // move
                            let move_c = new FB_MapPoint({
                                mp_lat_n : newLatLng.lat - currentCenter_c.mp_lat_n,
                                mp_lng_n : newLatLng.lng - currentCenter_c.mp_lng_n
                            })
                            currentCenter_c = new FB_MapPoint(newLatLng)

                            // update new latLngs
                            latlngs_al.forEach((latlng_l, latlngIndex_n) => {
                                let newLatLng = {lat : latlng_l.lat + move_c.mp_lat_n, lng : latlng_l.lng + move_c.mp_lng_n}
                                latlngs_al[latlngIndex_n] = newLatLng
                            })

                            // update questBody and leafletMap
                            polygon_l.setLatLngs(latlngs_al)
                            dragableMarkers_al.forEach(dragableMarker_l => {
                                dragableMarker_l.setLatLng({
                                    lat : dragableMarker_l.getLatLng().lat + move_c.mp_lat_n,
                                    lng : dragableMarker_l.getLatLng().lng + move_c.mp_lng_n,
                                })
                            })

                            for(let index_n in latlngs_al){
                                this.p_mapData_c.md_polygons_ac[polygonIndex_n].mdp_points_byIndex_c[index_n] = new FB_MapPoint({mp_lat_n : latlngs_al[index_n].lat, mp_lng_n : latlngs_al[index_n].lng} )
                            }

                        }))

                });
            },
            m_userEvents_clickEditBtn_editRiddleMarker_set_f(){

                this.riddles_markers_al.forEach((marker_l, index_n) => {

                    let current_qb_riddle_c = this.p_qb_riddles_ac[index_n]

                    this.editMarkers_al.push(
                        this.m_addDraggableMarker_fl(
                            current_qb_riddle_c.qbr_riddlePosition_c,
                            (newLatLng_o)=> {

                                marker_l.setLatLng(newLatLng_o)
                                current_qb_riddle_c.qbr_riddlePosition_c = new FB_MapPoint(newLatLng_o)

                                if(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.markers_route){

                                    // update next path
                                    if(index_n < this.riddles_paths_al.length){
                                        let latLngs_ao = this.riddles_paths_al[index_n].getLatLngs()
                                        latLngs_ao[0] = newLatLng_o

                                        this.riddles_paths_al[index_n].setLatLngs(latLngs_ao)
                                    }

                                    // update prev path
                                    if(index_n > 0){
                                        let latLngs_ao = this.riddles_paths_al[index_n-1].getLatLngs()
                                        latLngs_ao[latLngs_ao.length-1] = newLatLng_o
                                        this.riddles_paths_al[index_n-1].setLatLngs(latLngs_ao)
                                    }
                                }

                            }))

                })
            },
            m_userEvents_clickEditBtn_editRiddleRectangle_set_f(){

                let operators_as = ["+", "-"]

                this.rectangles_al.forEach((rectangle, index_n) => {

                    let current_qb_riddle_c = this.p_qb_riddles_ac[index_n]

                    this.editMarkers_al.push(this.m_addDraggableMarker_fl(
                        current_qb_riddle_c.qbr_riddlePosition_c,
                        (newLatLng)=> {

                            let newLatLng_c =  new FB_MapPoint(newLatLng)

                            // this.p_qb_riddles_ac.forEach( (other_qb_riddle_c, riddleIndex_n) => {
                            //     if(riddleIndex_n === index_n){
                            //         return
                            //     }
                            //
                            //     // if ractengles are close
                            //     ['mp_lat_n', 'mp_lng_n'].forEach(att => {
                            //         operators_as.forEach(operator => {
                            //
                            //             let border_otherRiddle =
                            //                 eval(other_qb_riddle_c.qbr_riddlePosition_c[att] + operator + (other_qb_riddle_c.qbr_rectangleSize_c[att]/2))
                            //
                            //             let border_currentRiddle =
                            //                 eval(newLatLng_c[att] +  enum_oppositeOperators[operator] + (current_qb_riddle_c.qbr_rectangleSize_c[att]/2))
                            //
                            //             if(Math.abs(border_otherRiddle - border_currentRiddle) < this.co_getMinDistance_fn){
                            //                 newLatLng_c[att] = eval(border_otherRiddle + operator + current_qb_riddle_c.qbr_rectangleSize_c[att]/2)
                            //             }
                            //
                            //             border_otherRiddle =
                            //                 eval(other_qb_riddle_c.qbr_riddlePosition_c[att] + operator + (other_qb_riddle_c.qbr_rectangleSize_c[att]/2))
                            //
                            //             border_currentRiddle =
                            //                 eval(newLatLng_c[att] +  operator + (current_qb_riddle_c.qbr_rectangleSize_c[att]/2))
                            //
                            //             if(Math.abs(border_otherRiddle - border_currentRiddle) < this.co_getMinDistance_fn){
                            //                 newLatLng_c[att] = eval(border_otherRiddle + enum_oppositeOperators[operator] + current_qb_riddle_c.qbr_rectangleSize_c[att]/2)
                            //             }
                            //
                            //         })
                            //     })
                            // })

                            // update rectangle position
                            rectangle.setBounds(this.m_getBounds_faan(newLatLng_c, current_qb_riddle_c.qbr_rectangleSize_c))
                            this.rectangles_numbersMarkers_al[index_n].setLatLng(
                                this.m_getLocation_fan(newLatLng_c, current_qb_riddle_c.qbr_rectangleSize_c))

                            // update questBody
                            current_qb_riddle_c.qbr_riddlePosition_c = newLatLng_c

                            // set other marker
                            operators_as.forEach(operator => {
                                let otherDragableMarker_l = dragableMarkers_byOperatorName[operator]
                                otherDragableMarker_l.setLatLng({
                                    lat: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + operator + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lat_n / 2)),
                                    lng: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lng_n + enum_oppositeOperators[operator] + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lng_n / 2)),
                                })
                            })
                        }))


                    // move corners
                    let dragableMarkers_byOperatorName = {}
                    operators_as.forEach(operator => {

                        // left and right
                        dragableMarkers_byOperatorName[operator] =
                            this.m_addDraggableMarker_fl(
                                new FB_MapPoint({
                                    mp_lat_n: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + operator + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lat_n / 2)),
                                    mp_lng_n: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lng_n +  enum_oppositeOperators[operator] + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lng_n / 2)),
                                }),
                                (newLatLng)=> {

                                    let newRectangleSizeHalf_c = new FB_MapPoint({
                                        mp_lat_n : (newLatLng.lat - current_qb_riddle_c.qbr_riddlePosition_c.mp_lat_n),
                                        mp_lng_n : (newLatLng.lng - current_qb_riddle_c.qbr_riddlePosition_c.mp_lng_n)
                                    })


                                    // set questBody data
                                    current_qb_riddle_c.qbr_rectangleSize_c = new FB_MapPoint({
                                        mp_lat_n : Math.abs(newRectangleSizeHalf_c.mp_lat_n) * 2,
                                        mp_lng_n : Math.abs(newRectangleSizeHalf_c.mp_lng_n) * 2
                                    })

                                    // set rectangle data
                                    rectangle.setBounds(this.m_getBounds_faan(current_qb_riddle_c.qbr_riddlePosition_c, current_qb_riddle_c.qbr_rectangleSize_c))
                                    this.rectangles_numbersMarkers_al[index_n].setLatLng(
                                        this.m_getLocation_fan(current_qb_riddle_c.qbr_riddlePosition_c, current_qb_riddle_c.qbr_rectangleSize_c))

                                    // set other marker
                                    let otherDragableMarker_l = dragableMarkers_byOperatorName[enum_oppositeOperators[operator]]
                                    otherDragableMarker_l.setLatLng({
                                        lat: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lat_n + enum_oppositeOperators[operator] + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lat_n / 2)),
                                        lng: eval(current_qb_riddle_c.qbr_riddlePosition_c.mp_lng_n + operator + (current_qb_riddle_c.qbr_rectangleSize_c.mp_lng_n / 2)),
                                    })
                                })

                        this.editMarkers_al.push(dragableMarkers_byOperatorName[operator])
                    })


                })
            },
            m_userEvents_clickEditBtn_editImageOverlay_set_f(){

                this.overlayImages_al.forEach((imageOverlay_o, index_n) => {

                    let md_overlayImage_c = this.p_mapData_c.md_overlayImages_ac[index_n]

                    let draggable_northEast_o = this.m_addDraggableMarker_fl(
                        md_overlayImage_c.mdoi_northEast_c,
                        (new_northEast_o)=> {

                            // update questBody
                            md_overlayImage_c.mdoi_northEast_c = new FB_MapPoint(new_northEast_o)

                            // update draggable marker
                            let newCenter_c = this.m_getTwoPointCenter_c(md_overlayImage_c.mdoi_northEast_c, md_overlayImage_c.mdoi_southWest_c)
                            draggable_center_o.setLatLng([newCenter_c.mp_lat_n, newCenter_c.mp_lng_n])

                            // update rectangle position
                            imageOverlay_o.setBounds([{lat : md_overlayImage_c.mdoi_southWest_c.mp_lat_n, lng: md_overlayImage_c.mdoi_southWest_c.mp_lng_n}, {lat: md_overlayImage_c.mdoi_northEast_c.mp_lat_n, lng :md_overlayImage_c.mdoi_northEast_c.mp_lng_n}])

                        })

                    let draggable_southWest_o =this.m_addDraggableMarker_fl(
                        md_overlayImage_c.mdoi_southWest_c,
                        (new_southWest_o)=> {
                            // update questBody
                            md_overlayImage_c.mdoi_southWest_c = new FB_MapPoint(new_southWest_o)

                            // update draggable marker
                            let newCenter_c = this.m_getTwoPointCenter_c(md_overlayImage_c.mdoi_northEast_c, md_overlayImage_c.mdoi_southWest_c)
                            draggable_center_o.setLatLng([newCenter_c.mp_lat_n, newCenter_c.mp_lng_n])

                            // update rectangle position
                            imageOverlay_o.setBounds([{lat : md_overlayImage_c.mdoi_southWest_c.mp_lat_n, lng: md_overlayImage_c.mdoi_southWest_c.mp_lng_n}, {lat: md_overlayImage_c.mdoi_northEast_c.mp_lat_n, lng :md_overlayImage_c.mdoi_northEast_c.mp_lng_n}])
                        })

                    let draggable_center_o = this.m_addDraggableMarker_fl(
                        this.m_getTwoPointCenter_c(md_overlayImage_c.mdoi_northEast_c, md_overlayImage_c.mdoi_southWest_c),
                        (new_southWest_o)=> {

                            let newCenter_c = new FB_MapPoint(new_southWest_o)
                            let oldCenter_c = this.m_getTwoPointCenter_c(md_overlayImage_c.mdoi_northEast_c, md_overlayImage_c.mdoi_southWest_c)

                            let centerGap_c = new FB_MapPoint({
                                mp_lng_n : newCenter_c.mp_lng_n - oldCenter_c.mp_lng_n,
                                mp_lat_n : newCenter_c.mp_lat_n - oldCenter_c.mp_lat_n})


                            md_overlayImage_c.mdoi_northEast_c = new FB_MapPoint({mp_lng_n : md_overlayImage_c.mdoi_northEast_c.mp_lng_n + centerGap_c.mp_lng_n, mp_lat_n : md_overlayImage_c.mdoi_northEast_c.mp_lat_n + centerGap_c.mp_lat_n})
                            md_overlayImage_c.mdoi_southWest_c = new FB_MapPoint({mp_lng_n : md_overlayImage_c.mdoi_southWest_c.mp_lng_n + centerGap_c.mp_lng_n, mp_lat_n : md_overlayImage_c.mdoi_southWest_c.mp_lat_n + centerGap_c.mp_lat_n})

                            draggable_northEast_o.setLatLng([md_overlayImage_c.mdoi_northEast_c.mp_lat_n, md_overlayImage_c.mdoi_northEast_c.mp_lng_n])
                            draggable_southWest_o.setLatLng([md_overlayImage_c.mdoi_southWest_c.mp_lat_n, md_overlayImage_c.mdoi_southWest_c.mp_lng_n])

                            imageOverlay_o.setBounds([
                                {lat : md_overlayImage_c.mdoi_southWest_c.mp_lat_n, lng: md_overlayImage_c.mdoi_southWest_c.mp_lng_n},
                                {lat: md_overlayImage_c.mdoi_northEast_c.mp_lat_n, lng :md_overlayImage_c.mdoi_northEast_c.mp_lng_n}
                            ])

                        })

                    this.editMarkers_al.push(draggable_northEast_o)
                    this.editMarkers_al.push(draggable_southWest_o)
                    this.editMarkers_al.push(draggable_center_o)
                })
            },
            m_userEvents_clickEditBtn_editPath_set_f(){

                this.riddles_paths_al.forEach((polyline_l, index_n) => {

                    let current_qb_riddle_c = this.p_qb_riddles_ac[index_n]

                    this.m_userEvents_clickEditBtn_editPath_refresh(polyline_l, current_qb_riddle_c)

                })
            },
            m_userEvents_clickEditBtn_editPath_refresh(polyline_l, current_qb_riddle_c){

                //clear markers
                this.m_editDraggableMarkers_clearGroup_f(current_qb_riddle_c.qbr_riddleId_n)

                let latlng_ao = polyline_l.getLatLngs()
                for(let pathLatLngIndex_n=0 ; pathLatLngIndex_n< latlng_ao.length - 1; pathLatLngIndex_n++){

                    // move path draggableMarkers
                    if(pathLatLngIndex_n > 0){

                        let draggableMarkerIndex_n = this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n].length

                        this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n]
                            .push(this.m_addDraggableMarker_fl(
                                new FB_MapPoint(latlng_ao[pathLatLngIndex_n]),
                                (newLatLng)=> {

                                    latlng_ao[pathLatLngIndex_n] = newLatLng
                                    polyline_l.setLatLngs(latlng_ao)

                                    let latLng_left_o = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n-1], latlng_ao[pathLatLngIndex_n])
                                    let latLng_right_o = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], latlng_ao[pathLatLngIndex_n+1])


                                    let draggableMarker_left_o = this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n][draggableMarkerIndex_n-1]
                                    let draggableMarker_right_o = this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n][draggableMarkerIndex_n+1]


                                    draggableMarker_left_o.setLatLng(latLng_left_o)
                                    draggableMarker_right_o.setLatLng(latLng_right_o)

                                    let m1 =(latLng_left_o.lat - newLatLng.lat) /(latLng_left_o.lng - newLatLng.lng)
                                    let m2 =(newLatLng.lat - latLng_right_o.lat) /(newLatLng.lng - latLng_right_o.lng)

                                    if(this.m_userEvents_clickEditBtn_editPath_checkMinSlop_b(m1,m2) && draggableMarker_left_o.opacity !== 0){
                                        draggableMarker_left_o.setOpacity(0)
                                        draggableMarker_right_o.setOpacity(0)
                                    }else if(draggableMarker_left_o.opacity !== 1){
                                        draggableMarker_left_o.setOpacity(1)
                                        draggableMarker_right_o.setOpacity(1)
                                    }
                                },(newLatLng) => {
                                    let latLng_left_c = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n-1], latlng_ao[pathLatLngIndex_n])
                                    let latLng_right_c = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], latlng_ao[pathLatLngIndex_n+1])

                                    let m1 =(latLng_left_c.lat - newLatLng.lat) /(latLng_left_c.lng - newLatLng.lng)
                                    let m2 =(newLatLng.lat - latLng_right_c.lat) /(newLatLng.lng - latLng_right_c.lng)

                                    if(this.m_userEvents_clickEditBtn_editPath_checkMinSlop_b(m1,m2)){
                                        latlng_ao.splice(pathLatLngIndex_n,1)
                                        polyline_l.setLatLngs(latlng_ao)
                                        this.m_userEvents_clickEditBtn_editPath_refresh(polyline_l, current_qb_riddle_c)

                                        current_qb_riddle_c.qbr_pathToNextMission_ac.splice(pathLatLngIndex_n-1,1)
                                    }else{
                                        latlng_ao[pathLatLngIndex_n] = newLatLng
                                        polyline_l.setLatLngs(latlng_ao)

                                        current_qb_riddle_c.qbr_pathToNextMission_ac[pathLatLngIndex_n-1] = new FB_MapPoint(newLatLng)
                                    }

                                }
                                ))
                    }


                    // split path draggableMarkers
                    let addPoint_b = false
                    let leftDraggableMarker_o = null;
                    let rightDraggableMarker_o = null;
                    this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n]
                        .push(this.m_addDraggableMarker_fl(
                        new FB_MapPoint(this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], latlng_ao[pathLatLngIndex_n+1])),
                        (newLatLng)=> {

                            if(addPoint_b){
                                latlng_ao[pathLatLngIndex_n+1] = newLatLng
                                polyline_l.setLatLngs(latlng_ao)

                                let latLng_left_o = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], newLatLng)
                                let latLng_right_o = this.getTwoPointCenter_o(newLatLng, latlng_ao[pathLatLngIndex_n+2])

                                leftDraggableMarker_o.setLatLng(latLng_left_o)
                                rightDraggableMarker_o.setLatLng(latLng_right_o)

                                let m1 =(latLng_left_o.lat - newLatLng.lat) /(latLng_left_o.lng - newLatLng.lng)
                                let m2 =(newLatLng.lat - latLng_right_o.lat) /(newLatLng.lng - latLng_right_o.lng)

                                if(this.m_userEvents_clickEditBtn_editPath_checkMinSlop_b(m1,m2) && leftDraggableMarker_o.opacity !== 0){
                                    leftDraggableMarker_o.setOpacity(0)
                                    rightDraggableMarker_o.setOpacity(0)
                                }else if(leftDraggableMarker_o.opacity !== 1){
                                    leftDraggableMarker_o.setOpacity(1)
                                    rightDraggableMarker_o.setOpacity(1)
                                }

                            }else{
                                addPoint_b = true
                                latlng_ao.splice(pathLatLngIndex_n+1,0,newLatLng)
                                polyline_l.setLatLngs(latlng_ao)

                                leftDraggableMarker_o = this.m_addDraggableMarker_fl(
                                    new FB_MapPoint(this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], latlng_ao[pathLatLngIndex_n+1])),
                                    () => {}
                                )

                                rightDraggableMarker_o = this.m_addDraggableMarker_fl(
                                    new FB_MapPoint(this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n+1], latlng_ao[pathLatLngIndex_n+2])),
                                    () => {}
                                )

                                this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n]
                                    .push(leftDraggableMarker_o)
                                this.editMarkers_byGroupId_al[current_qb_riddle_c.qbr_riddleId_n]
                                    .push(rightDraggableMarker_o)

                            }
                        },
                        (newLatLng) => {


                            let latLng_left_o = this.getTwoPointCenter_o(latlng_ao[pathLatLngIndex_n], newLatLng)
                            let latLng_right_o = this.getTwoPointCenter_o(newLatLng, latlng_ao[pathLatLngIndex_n+2])

                            let m1 =(latLng_left_o.lat - newLatLng.lat) /(latLng_left_o.lng - newLatLng.lng)
                            let m2 =(newLatLng.lat - latLng_right_o.lat) /(newLatLng.lng - latLng_right_o.lng)

                            if(this.m_userEvents_clickEditBtn_editPath_checkMinSlop_b(m1,m2)){
                                latlng_ao.splice(pathLatLngIndex_n+1,1)
                                current_qb_riddle_c.qbr_pathToNextMission_ac.splice(pathLatLngIndex_n, 1)
                            }else{
                                latlng_ao[pathLatLngIndex_n+1] = newLatLng
                                current_qb_riddle_c.qbr_pathToNextMission_ac.splice(pathLatLngIndex_n,0,new FB_MapPoint(newLatLng))
                            }

                            this.m_userEvents_clickEditBtn_editPath_refresh(polyline_l, current_qb_riddle_c)

                        }))


                }

            },
            m_userEvents_clickEditBtn_editPath_checkMinSlop_b(m1, m2){



                if(Math.abs(m1) < 5){
                    return Math.abs(m1 - m2) < this.pathDisplayRightLeftDraggableMarkers_minSlop
                }else if(Math.abs(m1) < 10){
                    return Math.abs(m1 - m2) < 5
                }else {
                    return Math.abs(m1 - m2) < 10
                }


            },
            m_editDraggableMarkers_clearGroup_f(groupId){

                // remove all markers
                if(this.editMarkers_byGroupId_al[groupId]){
                    this.editMarkers_byGroupId_al[groupId].forEach(marker_l => {
                        marker_l.remove()
                    })
                }

                // clean array
                this.editMarkers_byGroupId_al[groupId] = []
            },
            m_userEvents_clickEditBtn_editMarkers_clear_f(){
                this.editMarkers_al.forEach(marker_l => {
                    marker_l.remove()
                })
                this.editMarkers_al = []
            },

            // ======= mounted ==========
            m_mounted_initMap_f(){

                this.mymap_l = L.map(this.p_mapUid_s, {
                    attributionControl  : false,
                    gestureHandling     : true,
                })
                L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);


                this.mymap_l.setView([this.p_mapData_c.md_center_c.mp_lat_n, this.p_mapData_c.md_center_c.mp_lng_n], this.p_mapData_c.md_zoom_n);

                // set osm
                if([enum_mapTypes.osm, enum_mapTypes.googleMap].includes(this.p_qb_metadata_c.qbm_mapMissions_mapType2_e)){

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 20,
                        minZoom: 4,
                    }).addTo(this.mymap_l);
                }else{
                    L.tileLayer('', {
                        maxZoom: 20,
                        minZoom: 4,
                    }).addTo(this.mymap_l);
                }


                // this.mymap_l.setMaxBounds(this.mymap_l.getBounds());

                this.mymap_l.keyboard.disable();

            },
            m_mounted_setPolygons_f(){

                this.p_mapData_c.md_polygons_ac = this.p_mapData_c.md_polygons_ac.filter(polygon_c => {

                    return obj_size_fn(polygon_c.mdp_points_byIndex_c) > 0
                })



                this.p_mapData_c.md_polygons_ac.forEach(polygon_c => {

                    this.m_drawOnMap_polygon_f(obj_toArray_fo(obj_map_fo(polygon_c.mdp_points_byIndex_c, (point_c => {return [point_c.mp_lat_n, point_c.mp_lng_n]}))))
                })

            },
            m_mounted_setOverlayImages_f(){

                this.p_mapData_c.md_overlayImages_ac.forEach((md_overlayImage_c, index_n) => {

                    this.m_drawOnMap_overlayImage_f(md_overlayImage_c.mdoi_imageUrl_s, md_overlayImage_c.mdoi_northEast_c, md_overlayImage_c.mdoi_southWest_c)
                })

            },
            m_mounted_setRiddles_markers_f(){

                if(this.p_qb_riddles_ac == null) {return}

                this.p_qb_riddles_ac.forEach((qb_riddle_c, index) => {
                    this.m_drawOnMap_marker_f(qb_riddle_c.qbr_riddlePosition_c, qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s)
                })
            },
            m_mounted_setMapDataEditAble_f(){
                this.mymap_l.on('move', (e) => {
                    this.p_mapData_c.md_zoom_n = this.mymap_l.getZoom();
                    this.p_mapData_c.md_center_c = new FB_MapPoint(this.mymap_l.getCenter());
                })
            },
            m_mounted_setEditMap_eventsListener_f(){

                let newRiddleRectangle_startingPoint_c = null
                let rectangle_l = null

                // 2) mousedown
                this.mymap_l.on('mousedown', (e) => {

                    if(this.clickDragMarker_b){
                        return
                    }

                    switch(this.editState_n){

                        case this.editStateOptions_byName_n.add_polygons:
                            this.m_mounted_setEditMap_eventsListener_polygon_click_f(e)
                            break;

                        case this.editStateOptions_byName_n.add_markers:
                            this.m_mounted_setEditMap_eventsListener_marker_click_f(e.latlng)
                            break;

                        case this.editStateOptions_byName_n.add_rectangles:
                        case this.editStateOptions_byName_n.add_overlay_image:
                            this.mymap_l.dragging.disable()

                            newRiddleRectangle_startingPoint_c = new FB_MapPoint(e.latlng)
                            let rectangleSize_c =  new FB_MapPoint({mp_lat_n : 1, mp_lng_n : 1})

                            rectangle_l = L.rectangle(
                                this.m_getBounds_faan(newRiddleRectangle_startingPoint_c, rectangleSize_c),
                                {
                                    color       : "green",
                                    weight      : 1,
                                    fillOpacity : 0,
                                }).addTo(this.mymap_l)

                            break;

                    }
                })

                // 3) mousemove
                this.mymap_l.on('mousemove', (e) => {

                    if(this.clickDragMarker_b){
                        return
                    }

                    switch(this.editState_n){

                        case this.editStateOptions_byName_n.add_polygons:
                            this.m_mounted_setEditMap_eventsListener_polygon_mousemove_f(e)
                            break;
                        case this.editStateOptions_byName_n.add_overlay_image:
                        case this.editStateOptions_byName_n.add_rectangles:
                            if(newRiddleRectangle_startingPoint_c != null && rectangle_l != null){
                                this.m_mounted_setEditMap_eventsListener_riddleSquare_mousemove(rectangle_l, newRiddleRectangle_startingPoint_c, new FB_MapPoint(e.latlng))
                            }

                            break;
                    }
                })

                // 4) mouseup
                this.mymap_l.on('mouseup', (e) => {

                    switch(this.editState_n){
                        case this.editStateOptions_byName_n.add_rectangles:
                            if(newRiddleRectangle_startingPoint_c != null && rectangle_l != null){
                                this.mymap_l.dragging.enable()
                                this.m_mounted_setEditMap_eventsListener_riddleSquare_mouseup(newRiddleRectangle_startingPoint_c, new FB_MapPoint(e.latlng))
                                newRiddleRectangle_startingPoint_c = null
                                rectangle_l.remove()
                                rectangle_l = null
                            }
                            break;
                        case this.editStateOptions_byName_n.add_overlay_image:
                            if(newRiddleRectangle_startingPoint_c != null && rectangle_l != null){
                                this.mymap_l.dragging.enable()
                                this.m_mounted_setEditMap_eventsListener_overlayImage_mouseup(newRiddleRectangle_startingPoint_c, new FB_MapPoint(e.latlng), false)
                                newRiddleRectangle_startingPoint_c = null
                                rectangle_l.remove()
                                rectangle_l = null
                            }
                            break;
                    }
                })

                // mouseout
                this.mymap_l.on('mouseout', (e) => {

                    switch(this.editState_n){

                        case this.editStateOptions_byName_n.add_polygons:
                            break;
                        case this.editStateOptions_byName_n.add_rectangles:
                        case this.editStateOptions_byName_n.add_overlay_image:
                            if(newRiddleRectangle_startingPoint_c != null && rectangle_l != null){
                                newRiddleRectangle_startingPoint_c = null
                                rectangle_l.remove()
                                rectangle_l = null
                            }
                            break;
                    }
                })
            },
            m_mounted_setEditMap_eventsListener_marker_click_f(latLng){

                // add to quest body
                this.pe_addQuestBodyRiddle_c(latLng)

                // add to map
                this.m_drawOnMap_marker_f(new FB_MapPoint({mp_lng_n : latLng.lng , mp_lat_n : latLng.lat}), "#000000")

                // draw route
                if(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.markers_route){

                    let qb_riddle1_c = this.p_qb_riddles_ac[this.p_qb_riddles_ac.length-2]
                    let qb_riddle2_c = this.p_qb_riddles_ac[this.p_qb_riddles_ac.length-1]

                    this.m_drawOnMap_path_f(qb_riddle1_c.qbr_riddlePosition_c, qb_riddle2_c.qbr_riddlePosition_c, qb_riddle1_c.qbr_pathToNextMission_ac)
                }

            },
            m_mounted_setEditMap_eventsListener_polygon_click_f(e){
                // start polygon
                if(this.new_polyline == null){
                    this.new_polyline = L.polyline([e.latlng], {color: 'red'})
                        .addTo(this.mymap_l);
                    this.new_firstLatlng = e.latlng
                    this.new_latLngs = [e.latlng]
                }else{

                    // finish polygon
                    if(this.m_closeLatlngs_b(this.new_firstLatlng, e.latlng)){

                        let latLngs_ao = this.new_polyline.getLatLngs()

                        if(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons) {
                            this.pe_addQuestBodyRiddle_c()
                        }

                        this.m_drawOnMap_polygon_f(latLngs_ao)

                        let latLng_ac = latLngs_ao.map(point_o => {return new FB_MapPoint({mp_lat_n : point_o.lat, mp_lng_n : point_o.lng})})

                        this.p_mapData_c.md_polygons_ac.push( new FB_MapData_Polygon({
                            mdp_points_byIndex_c: latLng_ac,
                        }))

                        this.new_polyline.remove()
                        this.new_polyline = null

                    // build polygon
                    }else{
                        this.new_latLngs.push(e.latlng)
                        this.new_polyline.setLatLngs(this.new_latLngs)
                    }
                }
            },
            m_mounted_setEditMap_eventsListener_polygon_mousemove_f(e){
                if(this.new_polyline != null){
                    let t = JSON.parse(JSON.stringify(this.new_latLngs))
                    // finish polygon

                    if(this.m_closeLatlngs_b(this.new_firstLatlng, e.latlng)){
                        t.push(this.new_firstLatlng)
                        // build polygon
                    }else{
                        t.push(e.latlng)
                    }
                    this.new_polyline.setLatLngs(t)
                }
            },
            m_mounted_setEditMap_eventsListener_riddleSquare_mousemove(rectangle_l, startingPoint_c, endingPoint_c){

                let rectangleDiff = new FB_MapPoint({
                    mp_lat_n : startingPoint_c.mp_lat_n - endingPoint_c.mp_lat_n,
                    mp_lng_n : startingPoint_c.mp_lng_n - endingPoint_c.mp_lng_n,
                })

                let riddlePosition_c = new FB_MapPoint({
                    mp_lat_n : startingPoint_c.mp_lat_n - (rectangleDiff.mp_lat_n/2),
                    mp_lng_n : startingPoint_c.mp_lng_n - (rectangleDiff.mp_lng_n/2),
                })

                let qbr_rectangleSize_c = new FB_MapPoint({
                    mp_lat_n : Math.abs(rectangleDiff.mp_lat_n),
                    mp_lng_n : Math.abs(rectangleDiff.mp_lng_n),
                })

                rectangle_l.setBounds(this.m_getBounds_faan(riddlePosition_c, qbr_rectangleSize_c))


            },
            m_mounted_setEditMap_eventsListener_riddleSquare_mouseup(startingPoint_c, endingPoint_c){

                let rectangleDiff =  new FB_MapPoint({
                    mp_lat_n : startingPoint_c.mp_lat_n - endingPoint_c.mp_lat_n,
                    mp_lng_n : startingPoint_c.mp_lng_n - endingPoint_c.mp_lng_n,
                })

                let riddlePosition_c = new FB_MapPoint({
                    mp_lat_n : startingPoint_c.mp_lat_n - (rectangleDiff.mp_lat_n/2),
                    mp_lng_n : startingPoint_c.mp_lng_n - (rectangleDiff.mp_lng_n/2),
                })

                let qbr_rectangleSize_c = new FB_MapPoint({
                    mp_lat_n: Math.abs(rectangleDiff.mp_lat_n),
                    mp_lng_n: Math.abs(rectangleDiff.mp_lng_n),
                })

                if(qbr_rectangleSize_c.mp_lat_n < gv_numbers.minRectangleSize || qbr_rectangleSize_c.mp_lng_n < gv_numbers.minRectangleSize){
                    notification_notify(ass_strings.oneWord_error, ass_strings.threeWords_tooSmallRectangle)
                    return
                }

                this.pe_addQuestBodyRiddle_c(riddlePosition_c, qbr_rectangleSize_c)
                this.m_drawOnMap_rectangle_fc(riddlePosition_c, qbr_rectangleSize_c, this.p_qb_riddles_ac.length -1)


            },
            m_mounted_setEditMap_eventsListener_overlayImage_mouseup(startingPoint_c, endingPoint_c){

                this.pe_chooseImage_f((image_c) => {
                    this.p_mapData_c.md_overlayImages_ac.push(new FB_MapData_OverlayImage({
                        mdoi_northEast_c    : startingPoint_c,
                        mdoi_southWest_c    : endingPoint_c,
                        mdoi_imageUrl_s     : image_c.fi_url_s,
                    }))

                    this.m_drawOnMap_overlayImage_f(image_c.fi_url_s, startingPoint_c, endingPoint_c)
                })
            },

            // ======= refresh ===========
            m_refresh_rectangles_f(groups_squares_b){

                obj_forEach_f(this.rectangles_images_byRiddleIndexL, image_l => {image_l.remove()})
                this.rectangles_al.forEach(rectangle => {rectangle.remove()})
                this.rectangles_numbersMarkers_al.forEach(markers_l => {markers_l.remove()})

                this.rectangles_images_byRiddleIndexL = {}
                this.rectangles_al = []
                this.rectangles_numbersMarkers_al= []

                if(this.p_qb_riddles_ac == null)
                    return


                this.p_qb_riddles_ac.forEach((qb_riddle_c, missionIndex_n) => {

                    let missionDrawIndex_n = 0
                    if(groups_squares_b){
                        let missionGroup_c = this.m_getMissionsGroup_fc(qb_riddle_c)
                        missionDrawIndex_n = missionGroup_c.qbmg_riddlesIds_an.indexOf(qb_riddle_c.qbr_riddleId_n)
                    }else{
                        missionDrawIndex_n = missionIndex_n
                    }

                    this.m_drawOnMap_rectangle_fc(qb_riddle_c.qbr_riddlePosition_c, qb_riddle_c.qbr_rectangleSize_c, missionDrawIndex_n)
                })

            },
            m_getMissionsGroup_fc(mission_c){
                for(let groupIndex_n in this.p_missionGroups_ac) {

                    if(this.p_missionGroups_ac[groupIndex_n].qbmg_riddlesIds_an.includes(mission_c.qbr_riddleId_n)){
                        return this.p_missionGroups_ac[groupIndex_n]
                    }
                }
            },
            m_refresh_markers_f(){

                this.riddles_markers_al.forEach(image_l => {image_l.remove()})
                this.riddles_markers_al = []

                this.m_mounted_setRiddles_markers_f()

            },
            m_refresh_markersPaths_f(){

                if(this.p_qb_riddles_ac == null) {return}

                if(this.riddles_paths_al.length > 0){
                    this.riddles_paths_al.forEach( path_o => {
                        path_o.remove()
                    })
                    this.riddles_paths_al = []
                }


                for(let i =0; i< this.p_qb_riddles_ac.length - 1; i++ ){
                    let qb_riddle1_c = this.p_qb_riddles_ac[i]
                    let qb_riddle2_c = this.p_qb_riddles_ac[i+1]
                    this.m_drawOnMap_path_f(qb_riddle1_c.qbr_riddlePosition_c, qb_riddle2_c.qbr_riddlePosition_c, qb_riddle1_c.qbr_pathToNextMission_ac)
                }

            },

            // ======== helpers =========
            m_getBounds_faan(riddlePosition_c,  rectangleSize_c){
                return [
                    [riddlePosition_c.mp_lat_n - (rectangleSize_c.mp_lat_n/2), riddlePosition_c.mp_lng_n - (rectangleSize_c.mp_lng_n/2)],
                    [riddlePosition_c.mp_lat_n + (rectangleSize_c.mp_lat_n/2), riddlePosition_c.mp_lng_n + (rectangleSize_c.mp_lng_n/2)]
                ]
            },
            m_getLocation_fan(riddlePosition_c, rectangleSize_c){
                return [
                    riddlePosition_c.mp_lat_n + (rectangleSize_c.mp_lat_n/2),
                    riddlePosition_c.mp_lng_n - (rectangleSize_c.mp_lng_n/2)
                ]
            },
            m_closeLatlngs_b(latlng1, latlng2){

                return Math.abs(latlng1.lat - latlng2.lat) < this.co_getMinDistance_fn
                    && Math.abs(latlng1.lng - latlng2.lng) < this.co_getMinDistance_fn
            },
            m_addDraggableMarker_fl(mapPoint_c, cb_f, mouseUpCb_f){

                let dragMarker = L.marker(
                    [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n],
                    {
                        icon: L.icon({
                            iconUrl: ass_img_square_w,
                            iconSize:     [16, 16], // size of the icon
                            iconAnchor:   [8, 8], // point of the icon which will correspond to marker's location
                        }),
                        draggable:'true'
                    })
                    .addTo(this.mymap_l)
                    .on('drag', (event) => {
                        let marker = event.target;
                        let position_o = marker.getLatLng();

                        delete position_o.mp_lng_n
                        delete position_o.mp_lat_n

                        cb_f(position_o)
                    })
                    .on('dragstart', (event) => {
                        this.clickDragMarker_b = true
                    })
                    .on('dragend', (event) => {
                        this.clickDragMarker_b = false
                        let marker = event.target;
                        let position_o = marker.getLatLng();

                        delete position_o.mp_lng_n
                        delete position_o.mp_lat_n

                        if(mouseUpCb_f){mouseUpCb_f(position_o)}
                    })

                this.editMarkers_al.push(dragMarker);

                return dragMarker
            },
            m_polygonCenter_fc(latlngs_al) {
                let x = latlngs_al.map (x => x.lat);
                let y = latlngs_al.map (x => x.lng);
                let cx = (Math.min (...x) + Math.max (...x)) / 2;
                let cy = (Math.min (...y) + Math.max (...y)) / 2;

                return new FB_MapPoint({mp_lat_n : cx, mp_lng_n : cy});
            },
            getTwoPointCenter_o(latlng1_ao, latlng2_ao){
                return {
                    lat : (latlng1_ao.lat + latlng2_ao.lat) / 2,
                    lng : (latlng1_ao.lng + latlng2_ao.lng) / 2
                }
            },
            m_getTwoPointCenter_c(mapPoint1_ac, mapPoint2_ac){
                return new FB_MapPoint({
                    mp_lat_n : (mapPoint1_ac.mp_lat_n + mapPoint2_ac.mp_lat_n) / 2,
                    mp_lng_n : (mapPoint1_ac.mp_lng_n + mapPoint2_ac.mp_lng_n) / 2
                })
            },

            // ========= drawOnMap =======
            m_drawOnMap_overlayImage_f(fileUrl_s, northEast_c, southWest_c){


                let overlayImage = L.imageOverlay(fileUrl_s, [{lat : northEast_c.mp_lat_n, lng: northEast_c.mp_lng_n}, {lat: southWest_c.mp_lat_n, lng :southWest_c.mp_lng_n}], {zIndex: 0, interactive : true}).addTo(this.mymap_l);
                this.overlayImages_al.push(overlayImage)

                let onClick_f = (e, index) => {
                    if (this.editState_n === this.editStateOptions_byName_n.delete_overlay_image) {
                        this.overlayImages_al[index].remove()
                        this.overlayImages_al.splice(index, 1)
                        this.p_mapData_c.md_overlayImages_ac.splice(index, 1)
                    }
                }
                let index = this.overlayImages_al.length-1

                // click number rectangle
                overlayImage.on('click', (e) => {onClick_f(e, index)})
            },
            m_drawOnMap_polygon_f(latlngs){


                let polygonIndex_n = this.polygons_al.length

                let polygon_l = L.polygon(
                    latlngs,
                    {
                        color       : "purple",
                        weight      : 1,
                    }
                ).addTo(this.mymap_l);

                polygon_l.index = polygonIndex_n

                polygon_l.on('click', (e) => {

                    if(this.editState_n === this.editStateOptions_byName_n.delete_polygons){
                        polygon_l.remove()
                        this.polygons_al.splice(polygon_l.index, 1)

                        if(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.polygons){
                            this.p_qb_riddles_ac.splice(polygon_l.index, 1)
                        }

                        this.p_mapData_c.md_polygons_ac.splice(polygon_l.index, 1)
                        // reset polygons indexes
                        this.polygons_al.forEach((polygon_l, index) => {
                            polygon_l.index = index
                        })
                    }
                })

                this.polygons_al.push(polygon_l)
            },
            m_drawOnMap_marker_f(mapPoint_c, markerColor_s){

                let riddleMarker_l = L.marker(
                    [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n],
                    {
                        icon: L.divIcon({
                            className   : "",
                            html        : this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.markers
                                ? svg_getMarkerHtml_s(markerColor_s)
                                : svg_getMarkerHtml_s('#501078', this.riddles_markers_al.length + 1),
                            iconSize    : [38, 95], // size of the icon
                            iconAnchor  : [19, 40], // point of the icon which will correspond to marker's location
                        }),
                    })

                riddleMarker_l.addTo(this.mymap_l)
                riddleMarker_l.index = this.riddles_markers_al.length

                // add listeners
                riddleMarker_l.on('click', (e) => {

                    if(this.editState_n === this.editStateOptions_byName_n.delete_markers){
                        riddleMarker_l.remove()
                        this.riddles_markers_al.splice(riddleMarker_l.index, 1)
                        this.p_qb_riddles_ac.splice(riddleMarker_l.index, 1)

                        this.m_refresh_markers_f()
                        if(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e === enum_mapMissionsTypes.markers_route){
                            this.m_refresh_markersPaths_f()
                        }
                    }
                })

                this.riddles_markers_al.push(riddleMarker_l)

            },
            m_drawOnMap_path_f(startMapPoint_c, endMapPoint_c, pathToNextMission_ac){


                let riddlesPath_l =
                    L.polyline([
                            [startMapPoint_c.mp_lat_n, startMapPoint_c.mp_lng_n],
                            ...pathToNextMission_ac.map(mapPoint_c=>{return [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n]}),
                            [endMapPoint_c.mp_lat_n, endMapPoint_c.mp_lng_n]],
                        {})
                        .addTo(this.mymap_l)



                riddlesPath_l.on('click', (e) => {

                    if(this.editState_n === this.editStateOptions_byName_n.delete_path){

                        console.log(e)

                    }
                })


                this.riddles_paths_al.push(riddlesPath_l)


            },
            m_drawOnMap_rectangle_fc(riddlePosition_c, rectangleSize_c, index) {

                // numbers
                let marker_l = L.marker(
                    this.m_getLocation_fan(riddlePosition_c, rectangleSize_c),
                    {
                        icon: L.divIcon({
                            className: 'TQ_text_24px TQ_leaflet_rectangle_num',   // Set class for CSS styling
                            html: '' + (index + 1),
                        }),
                    })
                    .addTo(this.mymap_l)

                // Rectangle
                let rectangle_l = L.rectangle(
                    this.m_getBounds_faan(riddlePosition_c, rectangleSize_c),
                    {
                        color       : "purple",
                        weight      : 1,
                        fillOpacity : 0,

                    }).addTo(this.mymap_l)

                // Images
                if(this.p_qb_riddles_ac[index].qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s != null){
                    this.rectangles_images_byRiddleIndexL[index] = L.imageOverlay(
                        this.p_qb_riddles_ac[index].qbr_imgFile_blc_c[this.p_display_langCode_e].fi_url_s,
                        this.m_getBounds_faan(this.p_qb_riddles_ac[index].qbr_riddlePosition_c, this.p_qb_riddles_ac[index].qbr_rectangleSize_c),
                        {opacity: 0.5})
                }

                rectangle_l.index = index
                marker_l.index = index

                this.rectangles_al.push(rectangle_l)
                this.rectangles_numbersMarkers_al.push(marker_l)
                this.m_drawOnMap_rectangle_setListeners_f(rectangle_l, marker_l)
            },
            m_drawOnMap_rectangle_setListeners_f(rectangle_l, numberMarker_l) {

                // click rectangle
                let onClick_f = (e, index) => {
                    if (this.editState_n === this.editStateOptions_byName_n.delete_rectangles) {
                        this.rectangles_al[index].remove()
                        this.rectangles_al.splice(index, 1)
                        this.rectangles_numbersMarkers_al[index].remove()
                        this.p_qb_riddles_ac.splice(index, 1)
                    }
                }

                // click number rectangle
                rectangle_l.on('click', (e) => {onClick_f(e, rectangle_l.index)})
                // click number marker
                numberMarker_l.on('click', (e) => {onClick_f(e, numberMarker_l.index)})


            },

        },
        watch:{

            p_qb_riddles_ac:{
                handler(){

                    if(this.editState_n === this.editStateOptions_byName_n.delete){
                        if([enum_mapMissionsTypes.squares, enum_mapMissionsTypes.squares_hide, enum_mapMissionsTypes.squares_linear].includes(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e)) {
                            this.m_refresh_rectangles_f(false)
                        }else if([enum_mapMissionsTypes.squares_linear_groups, enum_mapMissionsTypes.squares_linear_groups_hide].includes(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e)){
                            this.m_refresh_rectangles_f(true)
                        }else{
                            this.m_refresh_markers_f()
                        }
                    }
                },
                deep: true,
            }
        },

        // lifeCircle
        mounted(){

            // 1) SET MAP
            this.m_mounted_initMap_f()

            // 2) SET POLYGONS
            this.m_mounted_setPolygons_f()

            // 3) set overlay svg
            this.m_mounted_setOverlayImages_f()

            // 4) SET RIDDLES
            switch(this.p_qb_metadata_c.qbm_mapMissions_missionsType_e){

                case enum_mapMissionsTypes.markers_route:
                    this.m_refresh_markersPaths_f()
                case enum_mapMissionsTypes.markers:
                case enum_mapMissionsTypes.numbers_hide:
                    this.m_mounted_setRiddles_markers_f()
                    break;

                case enum_mapMissionsTypes.squares_linear_groups_hide:
                case enum_mapMissionsTypes.squares_linear_groups:

                    this.m_refresh_rectangles_f(true)

                    break;

                case enum_mapMissionsTypes.squares_linear:
                case enum_mapMissionsTypes.squares_hide:
                case enum_mapMissionsTypes.squares:
                    this.m_refresh_rectangles_f(false)
                    break;
            }



            // 6) SET INTERACTIONS
            this.m_mounted_setEditMap_eventsListener_f()
            this.m_mounted_setMapDataEditAble_f()

        }
    }
</script>

<style scoped lang="scss">

    .root{
        position: relative;
        left: 0px;
        top: 0px;


        .lc_btns {
            position: absolute;
            top: 90px;
            left: 14px;
            cursor: pointer;
        }

        .lc_moreInfo{
            position: absolute;
            top: 0px;
            right: 0px;
        }

        .lc_chooseImage {
            position: absolute;
            top: 4px;
            right: 4px;
            cursor: pointer;
        }





    }

</style>